// eslint-disable-next-line no-unused-vars
import api from './api'
import meta from './modules/meta'
import standard from './modules/standard'

export default (resource) => {
  return {
    namespaced: true,
    modules: {
      meta: meta(),
      standard: standard(resource),
    },
    state: {},
    getters: {
      getUserNameById: (state) => (id) => {
        const { items } = state.standard
        const name = Object.keys(items).reduce((a, k) => [...a, items[k]],[]).find(a => a.admin_id === id)
        return name ? name.admin_name : 'Okänd'
      },
    },
    mutations: {},
    actions: {},
  }
}
